import { AppBar, Toolbar, IconButton, Box, Button, useScrollTrigger, } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useContext, useState } from "react";
import NavMenuItem from "./NavMenuItem";
import ResponsiveDrawer from "./ResponsiveDrawer";
// import { links } from "../../data/links";
import logo from "../../assets/logos/relic-logo-bw.png";
// import { analyze } from "../../utils/firebase/firestore-funcs";
import DialogContext from "../../context/DialogContext";
import SubscribeForm from "../Common/SubscribeForm";
import { currentSeason } from "../../data/currentSeason";
import HeaderHeightContext from "../../context/HeatherHeightContext";


const Header = ({ location }) => {

    const { ref } = useContext(HeaderHeightContext);
    const { setDialog } = useContext(DialogContext);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // const seasons = Array.from({ length: seasonSwitch ? year - 2021 : year - 2022 }, (_, i) => i + 2022);
    const trigger = useScrollTrigger({
        threshold: 100,
        disableHysteresis: true
    });
    const navItems = [
        {
            path: '/events', title: 'Events', menu: [
                { path: `/events/${currentSeason}`, title: `${currentSeason} Season` },
                { path: '/events/past', title: 'Archive' }
            ]
        },
        {
            path: '/about', title: 'About', menu: [
                { path: '/about/bio', title: 'Relic' },
                { path: '/about/mission', title: 'Mission' },
                { path: '/about/musicians', title: 'Musicians' },
                { path: '/about/journey', title: 'Journey' }
            ]
        },
        {
            path: '/support', title: 'Support', menu: [
                { path: '/support/donate', title: 'Give now!' },
                { path: '/support/tiers', title: 'Donor Tiers' },
                // { path: '/support/host', title: 'Host Relic' }
            ]
        },
        {
            path: '/media', title: 'Media', menu: [
                { path: '/media/videos', title: 'Videos' },
                { path: '/media/photos', title: 'Photos' },
                { path: '/media/concerts', title: 'Full Concerts' }
            ]
        },
        { path: '/contact', title: 'Contact' },
    ];


    function handleDrawerToggle() {
        setIsDrawerOpen(!isDrawerOpen);
    }

    return (
        <>
            <AppBar ref={ref} color={trigger || location?.pathname !== '/' ? 'primary' : 'transparent'} sx={{ transition: 'all 0.15s ease' }} position={'sticky'}>
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', }}>
                    <IconButton
                        color="secondary"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { xs: 'relative', lg: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box component={RouterLink} overflow={'hidden'} to={'/'} height={'80px'} minWidth={'80px'} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex' }, transition: 'all 0.08s ease' }} display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <img src={logo} alt="homepage" aria-label="home" width={'60%'} height={'auto'} />
                    </Box>
                    <Box justifyContent={'center'} flexGrow={1} component={"nav"} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        {navItems.map(({ path, title, menu }) => {
                            return <NavMenuItem key={title} menuTitle={title} menu={menu} path={path} color={'white'} />
                        })}
                    </Box>
                    <ResponsiveDrawer handleDrawerToggle={handleDrawerToggle} isDrawerOpen={isDrawerOpen} navItems={navItems} />
                    <Box width={'110px'}>
                        <Button color="secondary" sx={{ fontWeight: 'bold', width: '100%', letterSpacing: 1.5, px: 6, border: '2px solid', }} variant={trigger || location?.pathname !== '/' ? 'outlined' : 'contained'} onClick={() => setDialog({ type: 'subscription', component: <SubscribeForm /> })}>
                            Subscribe
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>
        </>
    );
};

export default Header;